import type { SplashPopup } from '@/services/splash/types';

export const getSplashId = (splash: SplashPopup) => {
  return splash.imageMobile.documentId;
};

export const buildSplashAcceptKey = (splash: SplashPopup) =>
  `tis_splash:${getSplashId(splash)}`;

export const ACCEPT_7_DAYS_SECONDS = 60 * 60 * 24 * 7;

export const LCV_HOMEPAGE_API_PATH = '/api/lcv-homepage';
export const CV_HOMEPAGE_API_PATH = '/api/cv-homepage';
